/* eslint-disable @typescript-eslint/no-use-before-define */
import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '../../Icon';
import { Nav } from './Nav';
import { INavItem } from './Navigation';

export interface NavItemProps {
  item: INavItem;
  openedTree: string;
  pathname: string;
  onClick: (url: string) => void;
}

export const NavItem: React.FC<NavItemProps> = ({
  openedTree,
  pathname,
  onClick,
  item: { url, submenu, title, text, icon, onClick: itemOnClick },
}) => {
  const active = pathname.startsWith(url);
  const opened = openedTree && openedTree.startsWith(url);
  const to = submenu ? '#0' : url;

  const handleOnClick = (e: React.SyntheticEvent<HTMLElement, MouseEvent>) => {
    if (submenu) {
      onClick(url);
      e.preventDefault();
      return;
    }

    itemOnClick?.();
  };

  return (
    <li
      className={classnames({
        'zoom-nav-selected': active,
        'zoom-nav-opened': opened,
      })}
      data-test-id={getTestId(url)}
    >
      <Link
        className={classnames('zoom-nav-item', { 'zoom-has-submenu': submenu })}
        title={title}
        onClick={handleOnClick}
        to={to}
      >
        {icon && <span className="zoom-icon">{icon}</span>}
        <span className="zoom-nav-item-label">{text}</span>
        {submenu && (
          <span className="zoom-submenu-arrow">
            <Icon kind="chevron-right" size={8} color="#fff" />
          </span>
        )}
      </Link>
      {submenu && <Nav items={submenu} openedTree={openedTree} pathname={pathname} setOpenedTree={onClick} />}
    </li>
  );
};

export const getTestId = (url: string) => `nav-item:${url.substr(1).split('/').join('|')}`;
